import { rolesEntityReducer } from '@/features/roles/store/entitySlice';
import { auditLogsReducer } from '@/features/auditLogs/store/slice';
import { reducer as bannersReducer } from '@/features/banners/store/slice';
import { blockedCheckoutsReducer } from '@/features/blockedCheckouts/store/slice';
import { blockedMTOsReducer } from '@/features/blockedMTOs/store/slice';
import { brokenSubscriptionsReducer } from '@/features/brokenSubscriptions/store/slice';
import { reducer as deepLinksReducer } from '@/features/deepLinks/store/slice';
import { reducer as discountsReducer } from '@/features/discounts/store/slice';
import { reducer as dsAgentsReducer } from '@/features/dsAgents/store/slice';
import { reducer as paymentRetriesReducer } from '@/features/paymentRetries/store/slice';
import { reducer as productsReducer } from '@/features/products/store/slice';
import { reducer as removalBatchesReducer } from '@/features/removalBatches/store/slice';
import { reducer as replacementBatchesReducer } from '@/features/replacementBatches/store/slice';
import { trialFunnelErrorsReducer } from '@/features/trialFunnelErrors/store/slice';
import { usersEntityReducer } from '@/features/users/store/entitySlice';
import { usersReducer } from '@/features/users/store/slice';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    banners: bannersReducer,
    discounts: discountsReducer,
    deepLinksEntity: deepLinksReducer,
    rolesEntity: rolesEntityReducer,
    users: usersReducer,
    usersEntity: usersEntityReducer,
    dsAgentsEntity: dsAgentsReducer,
    paymentRetries: paymentRetriesReducer,
    auditLogsEntity: auditLogsReducer,
    replacementBatches: replacementBatchesReducer,
    removalBatches: removalBatchesReducer,
    blockedMTOsEntity: blockedMTOsReducer,
    blockedCheckoutsEntity: blockedCheckoutsReducer,
    trialFunnelErrorsEntity: trialFunnelErrorsReducer,
    products: productsReducer,
    brokenSubscriptionsEntity: brokenSubscriptionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
